module.exports = __webpack_public_path__ + "static/media/dogs_real.ab766a99.png";